module.exports = __webpack_public_path__ + "media/images/icons/enablement-cad670575c5d06f5bf922a8772f65aff.png";